// extracted by mini-css-extract-plugin
export default {"checks":"ParallelsForm_checks__zwlGu","placeHolderShimmer":"ParallelsForm_placeHolderShimmer__W7aqp"};